<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="login-container">

            <!-- PASS MODIFICADO -->
            <div class="container max-width" *ngIf="!changePass && recoveryPassword === false">
                <div class="header">
                    <img src="assets/images/fad_personal_login.png" alt="Header Login">
                    <h1>
                        <p class="text">Assinar agora</p>
                    </h1>
                </div>
                <div class="form">
                    <form [formGroup]="form">
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input appToLowercase formControlName="email" type="text" matInput required
                                   autocomplete="off">
                            <mat-error *ngIf="form.controls.email.hasError('required')">Campo obrigatório</mat-error>
                            <mat-error
                                    *ngIf="!form.controls.email.hasError('required') && form.controls.email.hasError('emailFormat')">
                                E-mail inválido
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Senha</mat-label>
                            <input formControlName="password" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error>Campo obrigatório</mat-error>
                        </mat-form-field>
                        <div class="forgot">
                            <p (click)="recoveryPassword = true">Esqueci minha senha ></p>
                        </div>
                        <div class="actions">
                            <button id="inicar_sesion" [disabled]="form.invalid" class="submit-button"
                                    [ngClass]="{'disabled':form.invalid}" (click)="login()">
                                <p>ASSINAR AGORA</p>
                            </button>
                        </div>
                        <div class="no-account">
                            <p (click)="createAccount()">Você não tem uma conta?<br><span>Crie sua conta aqui</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS RECUPERAR -->
            <div class="container max-width" *ngIf="recoveryPassword === true">
                <div class="header">
                    <img src="assets/images/fad_personal_login.png" alt="Header Login">
                    <p class="text" style="margin-top: 20px">Recuperar<br>Senha</p>
                </div>
                <div class="form">
                    <form [formGroup]="formRecovery">
                        <div class="no-account" style="margin: 0 0 20px;">
                            <div class="text"><strong>Digite o e-mail com o qual você entra no portal.</strong></div>
                        </div>
                        <mat-form-field>
                            <input appToLowercase placeholder="Email" formControlName="email" type="text" matInput>
                            <mat-error *ngIf="formRecovery.controls.email.hasError('required')">Campo obrigatório
                            </mat-error>
                            <mat-error
                                    *ngIf="!formRecovery.controls.email.hasError('required') && formRecovery.controls.email.hasError('emailFormat')">
                                E-mail inválido
                            </mat-error>
                        </mat-form-field>
                        <div class="loading" *ngIf="loader">
                            <img src="assets/images/loader.gif">
                        </div>
                        <div class="actions">
                            <re-captcha *ngIf="formRecovery.valid && loader === false" (resolved)="resolved($event)"
                                        (error)="onError($event)"></re-captcha>
                        </div>
                        <div class="no-account">
                            <div class="text" *ngIf="formRecovery.invalid"><span>Se você não se lembra do seu e-mail, você precisa entrar em contato com o administrador.</span>
                            </div>
                            <br>
                            <p>
                                <button *ngIf="formRecovery.valid && loader === false && captcha" mat-raised-button
                                        (click)="recoveryPass()"><span>Recuperar</span>
                                </button>
                            </p>
                            <p (click)="recoveryPassword = false"><span>< Para retornar</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS RECUPERADO -->
            <div class="container max-width" *ngIf="changePass">
                <div class="header">
                    <img src="assets/images/fad_personal_login.png" alt="Header Login">
                    <p class="text" style="margin-top: 20px">Mude sua<br>senha</p>
                </div>
                <div class="form">
                    <form [formGroup]="formPass">
                        <div class="no-account" style="margin: 0 0 20px; cursor:none;">
                            <p><strong>Regras:</strong><br>
                                13 caracteres no mínimo<br>
                                Use pelo menos uma letra maiúscula<br>
                                Use pelo menos um número<br>
                                Use pelo menos um caractere especial</p>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>Nova senha</mat-label>
                            <input formControlName="passNew" [type]="hide ? 'password' : 'text'"
                                   matInput required autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passNew.hasError('required')">Campo obrigatório
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passNew.hasError('required') && formPass.controls.passNew.hasError('passFormat')">
                                Sua senha não atende aos requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Repita sua nova senha</mat-label>
                            <input formControlName="passRepit" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passRepit.hasError('required')">Campo obrigatório
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passRepit.hasError('required') && formPass.controls.passRepit.hasError('passFormat')">
                                Sua senha não atende aos requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-error *ngIf="checarSiSonIguales()">
                            Senhas nao sao as mesmas.
                        </mat-error>
                        <div class="actions">
                            <button [disabled]="formPass.invalid" [ngClass]="{'disabled':formPass.invalid}"
                                    class="submit-button" (click)="changePassword()">
                                <p>SALVE</p>
                            </button>
                        </div>
                        <div class="no-account">
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <!-- PASS NO RECUPERADO-->
            <div class="content-res" *ngIf="!changePass && recoveryPassword === false">
                <h1>Assinar agora</h1>
            </div>

            <div class="box-light-fondo" *ngIf="!changePass && recoveryPassword === false">
                <div class="wrapper">
                    <form [formGroup]="form">
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input appToLowercase formControlName="email" type="text" matInput required
                                   autocomplete="off">
                            <mat-error *ngIf="form.controls.email.hasError('required')">Campo obrigatório</mat-error>
                            <mat-error
                                    *ngIf="!form.controls.email.hasError('required') && form.controls.email.hasError('emailFormat')">
                                E-mail inválido
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Senha</mat-label>
                            <input formControlName="password" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error>Campo obrigatório</mat-error>
                        </mat-form-field>
                        <div class="forgot">
                            <p (click)="recoveryPassword = true">Esqueci minha senha</p>
                        </div>
                        <div class="actions">
                            <button id="inicar_sesion_movil" class="submit-button" [disabled]="form.invalid"
                                    [ngClass]="{'disabled':form.invalid}" (click)="login()">
                                <p>ASSINAR AGORA</p>
                            </button>
                        </div>
                        <div class="no-account">
                            <p (click)="createAccount()">Você não tem uma conta?<br><span>Crie sua conta aqui</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS RECUPERAR -->
            <div class="content-res" *ngIf="recoveryPassword === true">
                <h1>Recuperar Senha</h1>
            </div>

            <div class="box-light-fondo" *ngIf="recoveryPassword === true">
                <div class="wrapper">
                    <form [formGroup]="formRecovery">
                        <div class="no-account" style="margin: 0 0 20px;">
                            <div class="text"><strong>Digite o e-mail com o qual você entra no portal..</strong></div>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>E-mail</mat-label>
                            <input appToLowercase formControlName="email" type="text" matInput required
                                   autocomplete="off">
                            <mat-error *ngIf="formRecovery.controls.email.hasError('required')">Campo obrigatório
                            </mat-error>
                            <mat-error
                                    *ngIf="!formRecovery.controls.email.hasError('required') && formRecovery.controls.email.hasError('emailFormat')">
                                E-mail inválido
                            </mat-error>
                        </mat-form-field>
                        <div class="loading" *ngIf="loader">
                            <img src="assets/images/loader.gif">
                        </div>
                        <div class="no-account">
                            <re-captcha *ngIf="formRecovery.valid && loader === false" (resolved)="resolved($event)"
                                        (error)="onError($event)"></re-captcha>
                        </div>
                        <div class="no-account">
                            <div class="text" *ngIf="formRecovery.invalid"><span>Se você não se lembra do seu e-mail, você precisa entrar em contato com o administrador.</span>
                            </div>
                            <br>
                            <p>
                                <button *ngIf="formRecovery.valid && loader === false && captcha" mat-raised-button
                                        (click)="recoveryPass()"><span>Recuperar</span>
                                </button>
                            </p>
                            <p (click)="recoveryPassword = false"><span>< Para retornar</span></p>
                        </div>
                    </form>
                </div>
            </div>

            <!-- PASS NO RECUPERADO-->
            <div class="content-res" *ngIf="changePass">
                Mude sua senha
            </div>

            <div class="box-light-fondo" *ngIf="changePass">
                <div class="wrapper">
                    <form [formGroup]="formPass">
                        <div class="no-account" style="margin: 0 0 20px;">
                            <p><strong>Reglas:</strong><br>
                                13 caracteres no mínimo<br>
                                Use pelo menos uma letra maiúscula<br>
                                Use pelo menos um número<br>
                                Use pelo menos um caractere especial</p>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>Nova senha</mat-label>
                            <input formControlName="passNew" [type]="hide ? 'password' : 'text'"
                                   matInput required autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passNew.hasError('required')">Campo obrigatório
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passNew.hasError('required') && formPass.controls.passNew.hasError('passFormat')">
                                Sua senha não atende aos requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Repita sua nova senha</mat-label>
                            <input formControlName="passRepit" [type]="hide ? 'password' : 'text'" matInput required
                                   autocomplete="off">
                            <mat-icon matSuffix
                                      (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="formPass.controls.passRepit.hasError('required')">Campo obrigatório
                            </mat-error>
                            <mat-error
                                    *ngIf="!formPass.controls.passRepit.hasError('required') && formPass.controls.passRepit.hasError('passFormat')">
                                Sua senha não atende aos requisitos mínimos.
                            </mat-error>
                        </mat-form-field>
                        <mat-error *ngIf="checarSiSonIguales()">
                            Senhas nao sao as mesmas.
                        </mat-error>
                        <div class="actions">
                            <button [disabled]="formPass.invalid" [ngClass]="{'disabled':formPass.invalid}"
                                    class="submit-button" (click)="changePassword()">
                                <p>SALVE</p>
                            </button>
                        </div>
                        <div class="no-account">
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</app-template>
